import React from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/evse_charger_success.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { resetWifiConfig } from './wifiConfigSlice';

/* istanbul ignore next -- @preserve */
export function WifiConfigurationSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')} display="flex" flexDirection="column">
      <Center flexDirection="column" px={3} textAlign="center" flex={1}>
        <Image data-testid="ev-charger-image" src={chargerImg} alt="Charging Station Setup Successful" ml={7} my={4} />

        <Heading mt={2} size={'lg'}>
          {t('Set Up Hardware.setup successful')}
        </Heading>
        <Text data-testid="ev-setup-complete-text" mt={1}>
          {t('EVSE.connected to wifi')}
        </Text>

        <ArcButton
          data-testid="ev-charger-continue"
          onClick={() => {
            // This screen is only ever reached via the Wi-Fi edit flow (fresh onboarding success
            // navigates straight to tariff/device-status) — safe to unconditionally clear isEditing
            // here so it can't leak into a later, unrelated onboarding attempt in the same session.
            dispatch(resetWifiConfig());
            navigate('../device-wifi-configuration');
          }}
          mt="auto"
          mb={8}
          w={'100%'}
          arcColor="#3DCD57"
        >
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
